import React from "react";
import { Link } from "react-router-dom";

const TypicalAchievementsCard = ({ service }) => {
  // Ensure `Link` is imported at the top of the file:
  // import { Link } from 'react-router-dom';

  return (
    <div className="flex flex-col items-center">
      {/* Image with curved bottom-right using Tailwind */}
      <div className="h-[140px] w-[250px] relative overflow-hidden">
        <img
          src={service.imageUrl}
          alt={service.name}
          className="h-full w-full object-cover rounded-tr-2xl rounded-bl-2xl rounded-tl-2xl"
        />
        {/* This creates the curved bottom-right effect */}
        <div className="absolute bottom-0 right-0 w-6 h-6 bg-transparent border-b-2 border-r-2 border-transparent rounded-br-2xl"></div>
      </div>
      
      {/* Link styled as button below image; uses service.path prop */}
      <Link
        to={service.path || '/'}
        className="mt-4 block w-full bg-gradient-to-r from-orange-500 to-orange-600 text-white px-6 py-2 rounded-xl shadow-lg text-sm font-semibold hover:from-orange-600 hover:to-orange-700 transition-all text-center"
      >
        {service.name}
      </Link>
    </div>
  );
};

export default TypicalAchievementsCard;